module.exports = __webpack_public_path__ + "static/media/econotecho.d6186e6d.pdf";